"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _trackers = require("../../trackers");

var updateActorId = function updateActorId(userId) {
  _trackers.pulse.update({
    actor: {
      id: userId,
      realm: 'schibsted.com'
    }
  });

  _trackers.gtm.update({
    actorId: userId
  });
};

var Actor = function Actor() {
  var userId = (0, _reactRedux.useSelector)(function (state) {
    var _state$user;

    return state === null || state === void 0 ? void 0 : (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.id;
  });
  (0, _react.useEffect)(function () {
    updateActorId(userId);
  }, [userId]);

  if (userId) {
    updateActorId(userId);
  }

  return null;
};

var _default = Actor;
exports["default"] = _default;
//# sourceMappingURL=Actor.js.map